'use strict';

var getQueryParam = require('../utils/get_query');
module.exports = function () {
  if (getQueryParam('pf') === '139' || getQueryParam('pf') === '140' || getQueryParam('pf') === '142') {
    return true;
  }
  return false;
};